export interface MockReview {
  id: number;
  author_name: string;
  author_image?: string;
  pet_name: string;
  city: string;
  rating: number;
  content: string;
  sitter_name: string;
  created_at: string;
  is_published: boolean;
}

export const mockReviews: MockReview[] = [
  {
    id: 1,
    author_name: "伊藤 麻衣",
    author_image: "https://public.readdy.ai/ai/img_res/1cff1067f913cbb927d8642a41d848c7.jpg",
    pet_name: "ポチ",
    city: "ロンドン",
    rating: 5,
    content: "準備中",
    sitter_name: "田中 美咲",
    created_at: "2025-11-15",
    is_published: true
  },
  {
    id: 2,
    author_name: "渡辺 健一",
    author_image: "https://readdy.ai/api/search-image?query=japanese-man-casual-profile-photo-natural-smile-white-background-professional-photo&width=100&height=100&seq=rev2&orientation=squarish",
    pet_name: "ラテ",
    city: "シドニー",
    rating: 5,
    content: "佐藤さんのおかげで出張中も全く心配せず過ごせました。ラテは大きな公園で毎日のびのびと遊んでもらえて本当に幸せそうでした。",
    sitter_name: "佐藤 健太",
    created_at: "2025-10-22",
    is_published: true
  },
  {
    id: 3,
    author_name: "中島 由美",
    author_image: "https://readdy.ai/api/search-image?query=japanese-woman-warm-smile-natural-portrait-clean-background-casual-friendly-look&width=100&height=100&seq=rev3&orientation=squarish",
    pet_name: "モカ",
    city: "バンクーバー",
    rating: 5,
    content: "猫が苦手な預け先が多い中、山田さんは猫専門で本当に助かりました。モカも懐いてくれて、帰宅後もリラックスしていて安心しました。",
    sitter_name: "山田 愛子",
    created_at: "2025-09-30",
    is_published: true
  },
  {
    id: 4,
    author_name: "加藤 拓也",
    author_image: "",
    pet_name: "マックス",
    city: "ニューヨーク",
    rating: 5,
    content: "鈴木さんは獣医師免許を持っていて、マックスが少し体調を崩した時もすぐ適切に対応してくれました。プロフェッショナルな対応に感謝しかありません。",
    sitter_name: "鈴木 大輔",
    created_at: "2025-11-03",
    is_published: true
  },
  {
    id: 5,
    author_name: "松本 あゆみ",
    author_image: "https://readdy.ai/api/search-image?query=japanese-woman-glasses-natural-smile-portrait-clean-simple-background-warm-light&width=100&height=100&seq=rev5&orientation=squarish",
    pet_name: "チョコ",
    city: "パリ",
    rating: 5,
    content: "高橋さんに薬の投与もお任せしました。細かい指示通りにきちんとやってくださって、チョコの体調も崩れずに帰ってきました。また絶対お願いします！",
    sitter_name: "高橋 さくら",
    created_at: "2025-08-18",
    is_published: true
  },
  {
    id: 6,
    author_name: "橋本 直樹",
    author_image: "",
    pet_name: "ソラ",
    city: "シンガポール",
    rating: 4,
    content: "中村さんはとても活発なシッターさんで、ソラが毎日いっぱい走れてご機嫌でした。コミュニケーションも丁寧で安心して任せられました。",
    sitter_name: "中村 翔",
    created_at: "2025-07-25",
    is_published: true
  },
  {
    id: 7,
    author_name: "木村 彩花",
    author_image: "https://readdy.ai/api/search-image?query=japanese-young-woman-bright-smile-portrait-clean-white-background-natural-lighting-casual&width=100&height=100&seq=rev7&orientation=squarish",
    pet_name: "レオ",
    city: "メルボルン",
    rating: 5,
    content: "PawBridgeを使って本当に良かったです。海外でペットを預けるのが不安でしたが、日本語で安心してやりとりできました。レオも元気いっぱいで帰ってきました！",
    sitter_name: "田中 美咲",
    created_at: "2025-11-28",
    is_published: true
  },
  {
    id: 8,
    author_name: "小林 洋平",
    author_image: "",
    pet_name: "ナナ",
    city: "トロント",
    rating: 5,
    content: "初めての利用でしたが、マッチングから予約まで全部スムーズでした。シッターさんもとても親切で、また次回の旅行もPawBridgeを使う予定です。",
    sitter_name: "山田 愛子",
    created_at: "2025-10-10",
    is_published: true
  },
  {
    id: 9,
    author_name: "山口 紀子",
    author_image: "https://readdy.ai/api/search-image?query=middle-aged-japanese-woman-portrait-gentle-smile-natural-background-warm-tones-casual-photo&width=100&height=100&seq=rev9&orientation=squarish",
    pet_name: "クッキー",
    city: "フランクフルト",
    rating: 4,
    content: "日本語が通じるシッターさんに出会えてとても安心でした。クッキーも最初は緊張していましたが、すぐになついてくれたと聞いて嬉しかったです。",
    sitter_name: "高橋 さくら",
    created_at: "2025-09-14",
    is_published: true
  },
  {
    id: 10,
    author_name: "田村 慶太",
    author_image: "",
    pet_name: "ピート",
    city: "ロサンゼルス",
    rating: 5,
    content: "ピートが高齢犬でも丁寧に対応してくれました。散歩のペースも合わせてくれて、毎日報告を送ってもらえてすごく安心。これからも定期的に利用します。",
    sitter_name: "鈴木 大輔",
    created_at: "2025-12-01",
    is_published: true
  },
  {
    id: 11,
    author_name: "清水 梨沙",
    author_image: "https://readdy.ai/api/search-image?query=japanese-woman-30s-natural-portrait-smile-clean-background-bright-natural-light&width=100&height=100&seq=rev11&orientation=squarish",
    pet_name: "ミル",
    city: "アムステルダム",
    rating: 5,
    content: "短期旅行中に利用しました。ミルが病気がちなので不安でしたが、きめ細かいケアをしていただき本当に助かりました。また絶対にお願いしたいです！",
    sitter_name: "田中 美咲",
    created_at: "2025-12-10",
    is_published: true
  },
  {
    id: 12,
    author_name: "石田 祐輔",
    author_image: "",
    pet_name: "ベル",
    city: "ベルリン",
    rating: 5,
    content: "突然の出張でも快く引き受けていただきました。ベルもシッターさんにとても懐いて、旅行後も思い出すのかシッターさんの方向を向いて鳴いていました笑",
    sitter_name: "中村 翔",
    created_at: "2025-11-20",
    is_published: true
  },
  {
    id: 13,
    author_name: "川口 奈々",
    author_image: "https://readdy.ai/api/search-image?query=japanese-woman-portrait-genuine-smile-outdoor-blurred-background-natural-daylight&width=100&height=100&seq=rev13&orientation=squarish",
    pet_name: "ハル",
    city: "シドニー",
    rating: 4,
    content: "海外生活で日本語で相談できる場所が見つかって本当に嬉しかったです。ハルも食欲が落ちず、いつも通り過ごせていたと聞いて一安心しました。",
    sitter_name: "佐藤 健太",
    created_at: "2025-08-05",
    is_published: true
  },
  {
    id: 14,
    author_name: "林 俊介",
    author_image: "",
    pet_name: "ルナ",
    city: "ニューヨーク",
    rating: 5,
    content: "ルナは人見知りが激しいのですが、シッターさんの接し方が上手でびっくりしました。Pre-visitも丁寧に対応してもらい、信頼感が一気に上がりました。",
    sitter_name: "鈴木 大輔",
    created_at: "2025-10-30",
    is_published: true
  },
  {
    id: 15,
    author_name: "吉田 明美",
    author_image: "https://readdy.ai/api/search-image?query=japanese-senior-woman-cheerful-smile-portrait-white-background-warm-lighting&width=100&height=100&seq=rev15&orientation=squarish",
    pet_name: "タロ",
    city: "ロンドン",
    rating: 5,
    content: "PawBridgeを娘に勧めてもらって使い始めました。シッターさんが毎日動画を送ってくれてタロの様子がよく分かり、旅行中もずっと安心して過ごせました。",
    sitter_name: "田中 美咲",
    created_at: "2025-12-18",
    is_published: true
  }
];
